import { z } from "zod/v4";

const errorSchema = z.object({
  message: z.string(),
});

export class TRPCFetchError extends Error {
  public readonly url: URL | RequestInfo;
  public readonly options: Parameters<typeof fetch>[1];

  constructor({
    error,
    url,
    options,
  }: {
    error: unknown;
    url: URL | RequestInfo;
    options?: Parameters<typeof fetch>[1];
  }) {
    const { data } = errorSchema.safeParse(error);

    super(data ? data.message : "Unknown fetch error", {
      cause: error,
    });
    this.url = url;
    this.options = options;
  }
}
